<template>
  <b-navbar
    id="template-header"
    class="navbar default-layout-navbar p-0"
    toggleable="lg"
  >
    <div class="horizontal-menu">
      <nav class="navbar top-navbar col-lg-12 col-12 p-0">
        <div class="container">
          <div
            class="
              text-center
              navbar-brand-wrapper
              d-flex
              align-items-center
              justify-content-center
            "
          >
            <router-link class="navbar-brand brand-logo" to="/">
              <img src="@/assets/images/logo-desktop.png" alt="logo" />
            </router-link>
            <router-link class="navbar-brand brand-logo-mini" to="/">
              <img src="@/assets/images/logo-mini.svg" alt="logo" />
            </router-link>
          </div>

          <div
            class="
              navbar-menu-wrapper
              d-flex
              align-items-center
              justify-content-end
            "
          >
            <ul class="navbar-nav mr-lg-2" v-if="!isCustomer">
              <li class="nav-item nav-search d-none d-lg-block">
                <div class="input-group">
                  <div
                    class="input-group-prepend hover-cursor"
                    id="navbar-search-icon"
                  >
                    <span class="input-group-text" id="search">
                      <i class="mdi mdi-magnify"></i>
                    </span>
                  </div>
                  <input
                    v-model="searchkey"
                    v-on:keyup.enter="search"
                    type="text"
                    class="form-control"
                    id="navbar-search-input"
                    placeholder="Suche"
                    aria-label="search"
                    aria-describedby="search"
                  />
                </div>
              </li>
            </ul>

            <b-navbar-nav class="navbar-nav-right ml-auto">
              <b-nav-item-dropdown right class="nav-profile">
                <template slot="button-content">
                  <span
                    class="nav-link dropdown-toggle"
                    id="profileDropdown"
                    href="javascript:void(0);"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <div class="nav-profile-text">
                      <p class="mb-1 text-black">Sie sind eingeloggt</p>
                    </div>
                  </span>
                </template>
                <!--
                <b-dropdown-item class="preview-item">
                  <i class="mdi mdi-cached mr-2 text-success"></i> Profil
                </b-dropdown-item>
                -->
                <b-dropdown-item class="preview-item" @click="logout()">
                  <i class="mdi mdi-logout mr-2 text-primary"></i> Ausloggen
                </b-dropdown-item>
              </b-nav-item-dropdown>
            </b-navbar-nav>
            <button
              class="navbar-toggler navbar-toggler-right align-self-center"
              type="button"
              @click="toggleMobileSidebar()"
            >
              <span class="mdi mdi-menu"></span>
            </button>
          </div>
        </div>
      </nav>
      <nav class="bottom-navbar">
        <div class="container">
          <ul class="nav page-navigation">
            <li class="nav-item">
              <router-link class="nav-link" to="/">
                <i class="mdi mdi-home menu-icon"></i>
                <span class="menu-title">Start</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/locations/">
                <i class="mdi mdi-city menu-icon"></i>
                <span class="menu-title">Einrichtungen</span>
              </router-link>
            </li>
            <li class="nav-item" v-if="!isCustomer">
              <router-link class="nav-link" to="/billings/">
                <i class="mdi mdi-city menu-icon"></i>
                <span class="menu-title">Rechnungen</span>
              </router-link>
            </li>
       
            <!--
            <li class="nav-item mega-menu">
              <a href="javascript:void(0);" class="nav-link">
                <i class="mdi mdi-crosshairs-gps menu-icon"></i>
                <span class="menu-title">UI Elements</span>
                <i class="menu-arrow"></i>
              </a>
              <div class="submenu">
                <div class="col-group-wrapper row">
                  <div class="col-group col-md-4">
                    <div class="row">
                      <div class="col-12">
                        <p class="category-heading">Basic Elements</p>
                        <div class="submenu-item">
                          <div class="row">
                            <div class="col-md-6">
                              <ul>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/basic-ui/accordions/">Accordion</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/basic-ui/alerts/">Alerts</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/basic-ui/badges/">Badges</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/basic-ui/breadcrumbs/">Breadcrumbs</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/basic-ui/buttons/">Buttons</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/basic-ui/dropdowns/">Dropdowns</router-link>
                                </li>
                              </ul>
                            </div>
                            <div class="col-md-6">
                              <ul>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/basic-ui/modals/">Modals</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/basic-ui/paginations/">Paginations</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/basic-ui/progress/">Progress</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/basic-ui/tabs/">Tabs</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/basic-ui/tooltips/">Tooltips & Popovers</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/basic-ui/typography/">Typography</router-link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-group col-md-4">
                    <div class="row">
                      <div class="col-12">
                        <p class="category-heading">Advanced Elements</p>
                        <div class="submenu-item">
                          <div class="row">
                            <div class="col-md-6">
                              <ul>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/advanced-ui/dragula/">Dragula</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/advanced-ui/carousel/">Carousel</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/advanced-ui/loaders/">Loaders</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/advanced-ui/slider/">Slider</router-link>
                                </li>
                              </ul>
                            </div>
                            <div class="col-md-6">
                              <ul>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/advanced-ui/clipboard/">Clipboard</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/advanced-ui/tree-view/">Tree View</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/advanced-ui/context-menu/">Context Menu</router-link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-group col-md-4">
                    <p class="category-heading">Icons</p>
                    <ul class="submenu-item">
                      <li class="nav-item">
                        <router-link class="nav-link" to="/icons/flag-icons/">Flag icons</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link class="nav-link" to="/icons/fontawesome/">Font Awesome</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link class="nav-link" to="/icons/mdi-icons/">MDI</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link class="nav-link" to="/icons/simpleline/">Simple line icons</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link class="nav-link" to="/icons/themify-icons/">Themify icons</router-link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
            -->
          </ul>
        </div>
      </nav>

      <b-modal id="bv-modal-example" hide-footer>
        <template #modal-title> Suchergebnis </template>
        <div>
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>Träger</th>
                  <th>Einrichtung</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in searchresult"
                  :key="item.uid"
                  @click="openLocation(item)"
                  class="resultRow"
                >
                  <td>
                    <router-link
                      target="_blank"
                      :to="{
                        name: 'location-detail',
                        params: { uid: item.uid },
                      }"
                    >
                      {{ item.category }}
                    </router-link>
                  </td> 
                  <td>
                    <router-link
                      target="_blank"
                      :to="{
                        name: 'location-detail',
                        params: { uid: item.uid },
                      }"
                    >
                    {{ item.name }}
                  </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!--
        <b-button class="mt-3" block @click="$bvModal.hide('bv-modal-example')"
          >Schließen</b-button
        >
      -->
      </b-modal>
    </div>
  </b-navbar>
</template>

<script>
import { searchFull } from "@/services/locations.service";

export default {
  name: "app-header",
  data() {
    return {
      searchkey: null,
      searchresult: [],
    };
  }, 
  computed: {
    isCustomer: function () {
      return (
        this.$store.state.user_customer &&
        this.$store.state.user_company &&
        this.$store.state.user_company.length > 2
      );
    },
  },
  mounted() {
    var navItems = document.querySelectorAll(
      ".horizontal-menu .page-navigation >.nav-item"
    );
    document
      .querySelectorAll(".horizontal-menu .page-navigation >.nav-item")
      .forEach(function (el) {
        el.addEventListener("click", function () {
          for (var i = 0; i < navItems.length; i++) {
            if (navItems[i] == el) {
              el.classList.toggle("show-submenu");
            } else {
              navItems[i].classList.remove("show-submenu");
            }
          }
        });
      });
  },
  methods: {
    openLocation: (item) => {
      console.log(item);
    },
    toggleMobileSidebar: () => {
      document
        .querySelector(".bottom-navbar")
        .classList.toggle("header-toggled");
    },
    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some((path) => {
        return this.$route.path.indexOf(path) === 0; // current path starts with this path string
      });
    },
    handleSCroll() {
      let header = document.querySelector("body");
      if (window.scrollY > 70) {
        header.classList.add("fixed-on-scroll");
      } else {
        header.classList.remove("fixed-on-scroll");
      }
    },
    logout() {
      localStorage.removeItem("token");
      this.$router.push({ name: "login" });
    },
    search() {
      this.$bvModal.show("bv-modal-example");

      this.searchresult = [];

      searchFull({ searchkey: this.searchkey }).then((d) => {
        console.log("d", d);
        this.searchresult = d.data.loc_findings;
      });
    },
  },
  created() {
    window.addEventListener("scroll", this.handleSCroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleSCroll);
  },
  watch: {
    $route() {
      document
        .querySelector(".bottom-navbar")
        .classList.remove("header-toggled");
    },
  },
};
</script>

<style scoped>


.bottom-navbar {
  background-color: #00b3fc;
}

.page-navigation {
  justify-content: flex-start !important;
}
</style>